import { all, call } from "redux-saga/effects";
import authSaga from "./auth/authSaga";
import approvalsSaga from "./approvals/approvalsSaga";
import profileSaga from "./profile/profileSaga";

export default function* sagas() {
  yield all([ call(authSaga), call(approvalsSaga), call(profileSaga) ]);
}
